import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  dien_giai: z.string().optional(),
  status: z.string().optional(),
  user_id0: z.string().optional()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  dien_giai: '',
  status: 'ALL',
  user_id0: 'ALL'
};

export const formSchema = z.object({
  ma_so_thue: z.string().nullable().optional(),
  ten_kh_thue: z.string().nullable().optional(),
  dia_chi: z.string().nullable().optional(),
  dien_giai: z.string().nonempty('Diễn giải không được để trống'),
  ong_ba: z.string().nullable().optional(),
  e_mail: z.string().nullable().optional(),
  so_ct: z.string().nullable().optional(),
  ngay_ct: z.string().nullable().optional(),
  ngay_lct: z.string().nullable().optional(),
  ngay_ct0: z.string().nullable().optional(),
  ma_nt: z.string().nullable().optional(),
  ty_gia: z.coerce.number().nullable().optional(),
  status: z.string().nullable().optional(),
  transfer_yn: z.boolean().nullable().optional(),
  ma_tthddt: z.string().nullable().optional(),
  ma_pttt: z.string().nullable().optional(),
  so_ct_hddt: z.string().nullable().optional(),
  ngay_ct_hddt: z.string().nullable().optional(),
  so_ct2_hddt: z.string().nullable().optional(),
  ma_mau_ct_hddt: z.string().nullable().optional(),
  ma_gd: z.string().nullable().optional(),
  ma_mau_bc: z.string().nullable().optional(),
  ma_tc_thue: z.string().nullable().optional(),
  tk_thue: z.string().nullable().optional(),
  ten_vt_thue: z.string().nullable().optional(),
  ghi_chu: z.string().nullable().optional(),
  outvat_yn: z.boolean().nullable().optional(),
  t_so_luong: z.coerce.number().nullable().optional(),
  t_tien_nt: z.coerce.number().nullable().optional(),
  t_tien: z.coerce.number().nullable().optional(),
  t_thue_nt: z.coerce.number().nullable().optional(),
  t_thue: z.coerce.number().nullable().optional(),
  t_tt_nt: z.coerce.number().nullable().optional(),
  t_tt: z.coerce.number().nullable().optional()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  ma_so_thue: '',
  ten_kh_thue: '',
  dia_chi: '',
  dien_giai: '',
  ong_ba: '',
  e_mail: '',
  so_ct: '',
  ngay_ct: new Date().toISOString().split('T')[0],
  ngay_lct: new Date().toISOString().split('T')[0],
  ngay_ct0: new Date().toISOString().split('T')[0],
  ma_nt: '',
  ty_gia: 1,
  status: '5',
  transfer_yn: false,
  ma_tthddt: '0',
  ma_pttt: '',
  so_ct_hddt: '',
  ngay_ct_hddt: '',
  so_ct2_hddt: '',
  ma_mau_ct_hddt: '',
  ma_gd: 'TL',
  ma_mau_bc: '3',
  ma_tc_thue: '1',
  ten_vt_thue: '',
  ghi_chu: '',
  outvat_yn: false,
  t_so_luong: 0,
  t_tien_nt: 0,
  t_tien: 0,
  t_thue_nt: 0,
  t_thue: 0,
  t_tt_nt: 0,
  t_tt: 0
};
